<template>
    <div>
        <div class="d-flex" id="container">
            <div class="card">
                <div class="card-header m-0">
                    <div class="d-flex justify-content-between" id="group-details">
                        <span class="item" >
                            <input class="mr-2" type="checkbox"
                                v-model="selectedGroup"
                                :id="'group-' + group.id"
                                @change="select(group.id)"
                                :value="group.id"/>
                            <span class="text-primary cursor-pointer mr-2" @click.prevent="openModal(group)">{{ name }}</span>
                            <span> Contacts Selected: {{group.total_contacts}}</span>
                        </span>

                        <span class="cursor-pointer mr-2 text-muted">
                            <small>
                                <em>
                                (ID: {{ group.id }})
                                </em>
                            </small>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        props: {
            group: {required: true},
            // tags: {required: true},
            selectedGroups: {required: true},
            locationUser: {required: true},
            showBlock: {required: false, default: false},
            showUnblock: {required: false, default: false},
        },

        data: () => ({
            details: false
        }),

        computed: {
            selectedGroup: {
                get() {
                    return this.selectedGroups;
                },
                set() {
                }
            },

            name() {
                return this.group.name;
            },

            email() {
                return this.group.email;
            },

            phoneNumber() {
                return this.group.phone_number;
            },

            createdAt() {
                return this.group.created_at;
            },

            getInvitesLocations(){
                var locations = [];
                for (var i = this.group.locations.length - 1; i >= 0; i--) {
                    locations.push(this.group.locations[i].name);
                }

                if(locations.length == 0 ){
                    return "no locations";
                }

                return locations.join();
            }
        },

        methods: {
            select(id) {
                this.$emit('selected', id)
            },

            update(group) {
                this.$emit('updated', group);
            },

            remove(group) {
                this.$emit('deleted', group);
            },

            openModal(group) {
                this.$emit('openModal', group);
            },

            showDetails() {
                this.details = !this.details;
            },

            blockGroup(group) {
                this.$emit('block', group);
            },

            unblockGroup(group) {
                this.$emit('unblock', group);
            }
        }
    }
</script>


<style lang="scss" scoped>
    .d-flex {
        flex-wrap: wrap;
    }

    .item {
        flex: 1 1;
    }

    .card {
        border-radius: 0;
        flex-grow: 1;
    }

    #container {
        margin-bottom: -20px;
    }

    @media screen and (max-width: 991px) {
        #container {
            flex-direction: column;
            align-items: center;
        }
        .card {
            width: 100%
        }
        #group-details {
            flex-direction: column;
            text-align: center;
        }

        .item:not(:last-child) {
            margin-bottom: 10px;
        }
    }
</style>
